import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

export interface ValidateTokenResponse {
  role: string;
  userId: number;
  email: string;
  assignedDomains?: string[];
}

export async function validateToken(): Promise<ValidateTokenResponse> {
  const response = await axiosInstance.get(`${baseUrl}/auth/validate-token`);
  return response.data;
}
